export default __webpack_public_path__ + "static/media/body-background.d9330c81.png";